export default "__VITE_ASSET__55b378b7__"